export default "__VITE_ASSET__nFhEdcHF__"